import { classNames } from "../../utils";

type DividerProps = {
	className?: string;
	hideOnMobile?: boolean;
};

export const Divider = ({ className, hideOnMobile = true }: DividerProps) => {
	return (
		<div className={classNames(hideOnMobile ? "hidden sm:block" : "")} aria-hidden="true">
			<div className={classNames("py-2", className)}>
				<div className="border-neutral-faded border-t" />
			</div>
		</div>
	);
};
